
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[depositId]",
      function () {
        return require("private-next-pages/[depositId]/index.payments.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[depositId]"])
      });
    }
  